import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    guideId: Number
  }

  connect() {
    this.modal = document.getElementById('shareDietaryGuideModal')
  }

  async openModal(event) {
    event.preventDefault()

    const guideId = this.guideIdValue
    if (!guideId) return

    const modalBody = document.getElementById('shareDietaryGuideModalBody')
    modalBody.innerHTML = `
      <div class="text-center py-4">
        <div class="spinner-border text-success" role="status">
          <span class="sr-only">Cargando...</span>
        </div>
        <p class="mt-2 text-muted">Generando enlace...</p>
      </div>
    `

    $(this.modal).modal('show')

    try {
      const response = await fetch(`/dietary_guides/${guideId}/share`, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Accept': 'text/html'
        }
      })

      if (response.ok) {
        const html = await response.text()
        modalBody.innerHTML = html
        modalBody.querySelectorAll('script').forEach(oldScript => {
          const newScript = document.createElement('script')
          newScript.textContent = oldScript.textContent
          oldScript.parentNode.replaceChild(newScript, oldScript)
        })
      } else {
        modalBody.innerHTML = `
          <div class="alert alert-danger">
            Error al generar el enlace. Por favor intente nuevamente.
          </div>
        `
      }
    } catch (error) {
      console.error('Error:', error)
      modalBody.innerHTML = `
        <div class="alert alert-danger">
          Error de conexión. Por favor intente nuevamente.
        </div>
      `
    }
  }
}
